import { createFileRoute } from '@tanstack/react-router'
import { Target } from 'lucide-react'
import { z } from 'zod'
import { GoalsScreen } from '@/screens/improve/SCR-026-goals'

export const Route = createFileRoute('/_app/w/$ws/goals')({
  staticData: { screen: {"id":"SCR-026","title":"Goals & outcomes","group":"Improve","perm":"goal.read","pin":true,"order":1,"description":"What your agents are for, how it is measured and how it is going.", icon: Target } },
  validateSearch: z.object({
    status: z.enum(['active', 'archived']).optional(),
    g: z.string().max(200).optional(),
    days: z.union([z.literal(7), z.literal(30), z.literal(90)]).optional(),
  }),
  component: GoalsScreen,
})
